<div style="height: 100%;position: relative;">
  <div class="element desktop" (click)="globalService.isLogged ? openAccount() : loginInit()"
    [ngClass]="{'hover': hover}">
    <app-icon
      icon="person_outline"
      fill="1"
    >
    </app-icon>
  </div>

  <div class="element mobile" (click)="globalService.isLogged ? openAccount() : loginInit()">
    <app-icon
      icon="person_outline"
      fill="1"
    >
    </app-icon>
  </div>

</div>
